import { subscribe } from 'react-contextual';
import dataStore from './dataStore';

const SubscribeData = subscribe(dataStore)(({ children, ...props }) => children(props));
export default SubscribeData;
